import { EmptyState, LegacyCard, Page } from "@shopify/polaris"
import { Sentry, SentryErrorBoundary } from "channelwill-sentry-sdk"
function ErrorFallback({ error, resetErrorBoundary }: any) {
  return (
    <Page fullWidth>
      <LegacyCard sectioned>
        <EmptyState
          heading={t("SomethingWentWrong")}
          action={{
            content: t("Refresh"),
            onAction() {
              resetErrorBoundary()
            },
          }}
          image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
          fullWidth
        >
          <pre>{error.message}</pre>
        </EmptyState>
      </LegacyCard>
    </Page>
  )
}
const AppErrorBoundary = (props: { children: any }) => {
  return (
    <SentryErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        location.reload()
      }}
      onError={(error, info) => {
        console.log(error, info, "errLog")
        Sentry.captureReactException(error, info)
      }}
    >
      {props.children}
    </SentryErrorBoundary>
  )
}

export default AppErrorBoundary
